import { render, staticRenderFns } from "./Clecture.vue?vue&type=template&id=6f5daa91&"
import script from "./Clecture.vue?vue&type=script&lang=js&"
export * from "./Clecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports